import React, { useEffect, useState } from 'react';
import { FormControl, FormGroup, FormControlLabel } from '@mui/material';
import { Checkbox, FilterButton } from '@care/react-component-lib';
import { filterMultiToggleValues } from '@/utils/filters';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import {
  ServiceId,
  SERVICES_LIST_SENIOR_CARE,
  SERVICES_LIST_HOUSEKEEPING,
  SERVICES_LIST_TUTORING,
  SERVICES_LIST_PET_CARE,
  SERVICES_LIST_CARE_GIGS,
  SERVICES_LIST_SPECIAL_NEEDS,
} from '@/constants';
import { saveFilters } from '../../../utils/filtersStorage';

interface ServicesProps {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
  serviceId: string;
}

const Services = (props: ServicesProps) => {
  const [filterState, setFilterState] = useState<string[]>([]);
  const { handleClick, isClear, onChange, serviceId } = props;

  const isSelected = (value: any) => {
    const existing = filterState.find((element) => element === value);
    return existing !== undefined;
  };

  let servicesList;
  let filterLabel = 'Services';

  switch (serviceId) {
    case ServiceId.SENIRCARE:
      servicesList = SERVICES_LIST_SENIOR_CARE;
      break;
    case ServiceId.HOUSEKEEP:
      servicesList = SERVICES_LIST_HOUSEKEEPING;
      break;
    case ServiceId.TUTORINGX:
      servicesList = SERVICES_LIST_TUTORING;
      filterLabel = 'Subject Area';
      break;
    case ServiceId.PETCAREXX:
      servicesList = SERVICES_LIST_PET_CARE;
      break;
    case ServiceId.CAREGIGSX:
      servicesList = SERVICES_LIST_CARE_GIGS;
      break;
    case ServiceId.SPCLNEEDS:
      servicesList = SERVICES_LIST_SPECIAL_NEEDS;
      break;
    default:
      break;
  }

  const handleFilterMultiToggle = (event: React.SyntheticEvent) => {
    setFilterState(filterMultiToggleValues(event, filterState));
  };

  const handleApply = () => {
    saveFilters(
      {
        services: filterState,
      },
      onChange
    );

    const amplitudeData = {
      services: filterState,
    };

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, amplitudeData);
  };

  useEffect(() => {
    if (isClear) {
      setFilterState([]);
    }
  }, [isClear]);

  const renderCheckbox = (value: string, label: string) => {
    return (
      <FormControlLabel
        key={value}
        control={<Checkbox name="options" checked={isSelected(value)} />}
        label={label}
        onChange={handleFilterMultiToggle}
        value={value}
        sx={(theme) => ({ padding: theme.spacing(0, 2.25) })}
      />
    );
  };

  return (
    <FilterButton
      field="Services"
      label={filterLabel}
      selected={filterState.length > 0}
      onApply={handleApply}
      onClick={handleClick}
      sx={{ color: 'text.primary' }}>
      <FormControl variant="standard" component="fieldset" sx={{ width: '325px' }}>
        <FormGroup>
          {servicesList &&
            servicesList.map((service) => renderCheckbox(service.value, service.label))}
        </FormGroup>
      </FormControl>
    </FilterButton>
  );
};

export default Services;
